import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/producer-revenue-calculator/page.tsx")